import { render } from "./SittingTeam.vue?vue&type=template&id=14f0802b&scoped=true"
import script from "./SittingTeam.vue?vue&type=script&lang=js"
export * from "./SittingTeam.vue?vue&type=script&lang=js"

import "./SittingTeam.vue?vue&type=style&index=0&id=14f0802b&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14f0802b"]])

export default __exports__